import type { PerformanceRow } from "@redotech/redo-marketing-analytics/types";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";

/** Name over its send date and audience size. A marketing event that converted
 *  without sending in range has no date, so the phrase is dropped. */
export function MarketingEventNameCell({ row }: { row: PerformanceRow }) {
  const sentDate = row.SENT_DATE?.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const recipients = `${row.UNIQUE_RECIPIENTS.toLocaleString()} recipients`;
  return (
    <RedoTableTextCell
      subtext={sentDate ? `Sent ${sentDate} • ${recipients}` : recipients}
      text={row.NAME ?? row.KEY}
    />
  );
}
